export default {
  namespaced: true,
  state: {
    tempLoading: false,
    tempProvider: {},
    tempService: {},
    tempAppointment: {},
    tempAppointmentDetails: {},
    clinic: null,
    form: null,
    provider: null,
    service: null,
    vitalSignHideEmptyColumns: false,
    patientHistoryView: 'full',
    visitSummarySections: {
      diagnosis: true,
      notes: true,
      medication: true,
      services: true,
      files: true,
      documents: true,
    },
    vitalSignsSections: {
      height: true,
      weight: true,
      temperature: true,
      bpSys: true,
      bpDia: true,
      pulse: true,
      spo2: true,
      blood_glucose: true,
      respiratory_rate: true,
    },
    religions: [
      { text: 'Islam', value: 'islam' },
      { text: 'Buddha', value: 'buddha' },
      { text: 'Hindu', value: 'hindu' },
      { text: 'Christian', value: 'kristian' },
      { text: 'Sikh', value: 'sikh' },
      { text: 'Others', value: 'others' },
    ],
    races:[
      { text: 'Malay', value: 'melayu' },
      { text: 'Chinese', value: 'cina' },
      { text: 'Indian', value: 'india' },
      { text: 'Bumiputera (non-malay)', value: 'bumiputera' },
      { text: 'Others', value: 'others' },
    ],
    systemFields: [
      { id: 'ic', field_name: 'id', enable: true },
      { id: 'PHONE', field_name: 'phone', enable: true },
      { id: 'CREATED', field_name: 'date created', enable: true },
      { id: 'EMAIL', field_name: 'email', enable: true },
      { id: 'ADDRESS', field_name: 'address', enable: true },
      { id: 'GENDER', field_name: 'gender', enable: false },
      { id: 'AGE', field_name: 'age', enable: false },
      { id: 'NICKNAME', field_name: 'nickname', enable: false },
      { id: 'OCCUPATION', field_name: 'occoupation', enable: false },
      { id: 'MARITAL_STATUS', field_name: 'marital_status', enable: false },
      { id: 'INSTAGRAM', field_name: 'instagram', enable: false },
      { id: 'FACEBOOK', field_name: 'facebook', enable: false },
      { id: 'TWITTER', field_name: 'twitter', enable: false },
      { id: 'LINKEDIN', field_name: 'linkedin', enable: false },
      { id: 'TIKTOK', field_name: 'tiktok', enable: false },
    ],
    systemProviders: ['Doctor', 'Medical Assistant'],
    customFields: [],
    patientFields: [
      { id: 'ic', field_name: 'id', enable: true },
      { id: 'PHONE', field_name: 'phone', enable: true },
      { id: 'CREATED', field_name: 'date created', enable: true },
      { id: 'EMAIL', field_name: 'email', enable: true },
      { id: 'ADDRESS', field_name: 'address', enable: false },
      { id: 'GENDER', field_name: 'gender', enable: true },
      { id: 'RACE', field_name: 'race', enable: false },
      { id: 'RELIGION', field_name: 'religion', enable: false },
      { id: 'AGE', field_name: 'age', enable: false },
      { id: 'EMERGENCY', field_name: 'emergency contact', enable: false },
    ],
    appointmentFields: [
      { id: 'date', field_name: 'Date', enable: true, type: 'system', width: '125', sort_query_param: 'start__date' },
      { id: 'time', field_name: 'Schedule time', enable: true, type: 'system', width: '160', sort_query_param: 'start__time' },
      { id: 'services', field_name: 'Services', enable: true, type: 'system', sortable: false },
      { id: 'provider', field_name: 'Providers', enable: true, type: 'system', width: '180', sort_query_param: 'lead__member__user__first_name' },
      { id: 'paid', field_name: 'Payment', enable: true, type: 'system', sortable: false },
      { id: 'contacted', field_name: 'Sent Status', enable: true, type: 'system', sortable: false },
      // { id: 'responses', field_name: 'Responses', enable: true, type: 'system' },
    ],
    appointmentScheduleFields: [
      { id: 'services', field_name: 'Services', enable: true, type: 'system', sortable: false },
      { id: 'provider', field_name: 'Providers', enable: true, type: 'system', sortable: false },
      { id: 'total_sessions', field_name: 'Total Sessions', enable: true, type: 'system', sortable: false },
      { id: 'scheduled', field_name: 'Scheduled', enable: true, type: 'system', sortable: false },
      { id: 'pending', field_name: 'Dates Pending', enable: true, type: 'system', sortable: false },
    ],
    appointmentRequestFields: [
      { id: 'date', field_name: 'Date', enable: true, type: 'system', width: '125', sort_query_param: 'start__date' },
      { id: 'time', field_name: 'Schedule time', enable: true, type: 'system', width: '160', sort_query_param: 'start__time' },
      { id: 'services', field_name: 'Services', enable: true, type: 'system', sortable: false },
      { id: 'provider', field_name: 'Providers', enable: true, type: 'system', width: '180', sort_query_param: 'lead__member__user__first_name' },
    ],
    reviewInvitationFields: [
      { id: 'status', field_name: 'status', enable: true, type: 'system' },
      { id: 'last_appointment', field_name: 'last appt.', enable: true, type: 'system' },
    ],
    registrationFields: [
      { id: 'queue', field_name: 'Queue', enable: true, type: 'system', sort_query_param: ['code', 'number'] },
      { id: 'arrive', field_name: 'Arrive at', enable: true, type: 'system', sort_query_param: 'waiting_at' },
      { id: 'remarks', field_name: 'Visit notes', enable: true, type: 'system', sort_query_param: 'lead__remarks' },
      { id: 'provider', field_name: 'Doctor', enable: true, type: 'system', sortable: false },
      { id: 'payment', field_name: 'Payment', enable: true, type: 'system', sortable: false },
      { id: 'duration', field_name: 'Duration', enable: true, type: 'system', sortable: false },
      { id: 'status', field_name: 'Status', enable: true, type: 'system', sort_query_param: 'status' },
    ],
    reservationFields: [
      { id: 'reservation_no', field_name: 'Reservation No.', enable: true, type: 'system', sort_query_param: 'rid' },
      { id: 'item', field_name: 'Item', enable: true, type: 'system', sortable: false, width: 250 },
      { id: 'payment_status', field_name: 'Payment Status', enable: true, type: 'system', sortable: false },
      { id: 'reservation_status', field_name: 'Status', enable: true, type: 'system', sort_query_param: 'status' },
    ],
    preorderFields: [
      { id: 'preorder_no', field_name: 'Pre-order No.', enable: true, type: 'system', sortable: false },
      { id: 'item', field_name: 'Item', enable: true, type: 'system', sortable: false },
      { id: 'payment_status', field_name: 'Payment Status', enable: true, type: 'system', sortable: false },
      { id: 'preorder_status', field_name: 'Status', enable: true, type: 'system', sort_query_param: 'status' },
    ],
    inventoryFields: [
      { id: 'category', field_name: 'Category', enable: true, type: 'system', sort_query_param: 'category' },
      { id: 'groups', field_name: 'Groups', enable: true, type: 'system', sortable: false, width: 100 },
      { id: 'costPrice', field_name: 'Cost & Price', enable: true, type: 'system', sortable: false },
      { id: 'quantity', field_name: 'Stock', enable: true, type: 'system', sort_query_param: 'product__inventory_qty', width: 100 },
      { id: 'expiryDate', field_name: 'Expiry Date', enable: true, type: 'system', sortable: false },
    ],
    serviceFields: [
      { id: 'type', field_name: 'Type', enable: true, type: 'system', sort_query_param: 'type' },
      { id: 'description', field_name: 'Description', enable: true, type: 'system', sort_query_param: 'product__description' },
      { id: 'cost', field_name: 'Cost', enable: true, type: 'system', sort_query_param: 'cost' },
      { id: 'price', field_name: 'Price to patient', enable: true, type: 'system', sortable: false },
      { id: 'status', field_name: 'Status', enable: true, type: 'system', sort_query_param: 'product__status' },
    ],
    packageFields: [
      { id: 'stock', field_name: 'Stock', enable: true, type: 'system', sortable: false },
      { id: 'price', field_name: 'Price', enable: true, type: 'system', sort_query_param: 'product__price' },
      { id: 'items', field_name: 'Items', enable: true, type: 'system', sortable: false },
      { id: 'status', field_name: 'Status', enable: true, type: 'system', sort_query_param: 'product__status' },
    ],
    stocktakeFields: [
      { id: 'user', field_name: 'User', enable: true, type: 'system' },
      { id: 'inventory', field_name: 'Inventories', enable: true, type: 'system' },
      { id: 'start_date', field_name: 'Start date', enable: true, type: 'system' },
      { id: 'end_date', field_name: 'End date', enable: true, type: 'system' },
      { id: 'status', field_name: 'Status', enable: true, type: 'system' },
    ],
    locationFields: [
      { id: 'created', field_name: 'Created date', enable: true, type: 'system' },
      { id: 'inventory', field_name: 'Inventories', enable: true, type: 'system' },
    ],
    userFields: [
      { id: 'role', field_name: 'Role', enable: true, type: 'system' },
      { id: 'service', field_name: 'Service', enable: true, type: 'system' },
      { id: 'availability', field_name: 'Availability', enable: true, type: 'system' },
      { id: 'overrides', field_name: 'Overrides', enable: true, type: 'system' },
      { id: 'status', field_name: 'Status', enable: true, type: 'system' },
    ],
    billingFields: [
      { id: 'status', field_name: 'Status', enable: true, type: 'system' },
      { id: 'invoice_no', field_name: 'Invoice no', enable: true, type: 'system', width: '120' },
      { id: 'payment', field_name: 'Payment method', enable: true, type: 'system' },
      { id: 'claim_status', field_name: 'Claim status', enable: true, type: 'system' },
      { id: 'record_date', field_name: 'Created date', enable: true, type: 'system', width: '140' },
    ],
    inventoryInvoiceFields: [
      { id: 'status', field_name: 'Status', enable: true, type: 'system' },
      { id: 'amount_remaining', field_name: 'Unpaid balance', enable: true, type: 'system' },
      { id: 'invoice_no', field_name: 'Invoice no', enable: true, type: 'system' },
      { id: 'seller', field_name: 'Seller', enable: true, type: 'system' },
      { id: 'due_at', field_name: 'Due date', enable: true, type: 'system', width: '140' },
      { id: 'record_date', field_name: 'Date issued', enable: true, type: 'system', width: '140' },
      { id: 'notes', field_name: 'Remarks', enable: true, type: 'system' },
    ],
    databinKey: null,
    doctorVisitFields: [
      { id: 'formatted_date', field_name: 'Visit date', enable: true, type: 'system' },
      { id: 'doctor_name', field_name: 'Doctor', enable: true, type: 'system' },
      { id: 'formatted_diagnoses', field_name: 'Diagnoses', enable: true, type: 'system' },
      { id: 'invoice', field_name: 'Payment status', enable: true, type: 'system' },
    ],
    nonDoctorVisitFields: [
      { id: 'formatted_date', field_name: 'Visit date', enable: true, type: 'system' },
      { id: 'doctor_name', field_name: 'Doctor', enable: true, type: 'system' },
      { id: 'payment_methods', field_name: 'Payment method', enable: true, type: 'system' },
      { id: 'invoice', field_name: 'Payment status', enable: true, type: 'system' },
    ],
    allPrescriptionReportFields: [
      { id: 'drugLabel', field_name: 'Drug label', enable: true, type: 'system' },
      { id: 'created', field_name: 'Date and time', enable: true, type: 'system' },
      { id: 'leadIC', field_name: 'Patient id', enable: true, type: 'system' },
      { id: 'name', field_name: 'Patient/Supplier name', enable: true, type: 'system' },
      { id: 'details', field_name: 'Details', enable: true, type: 'system' },
      { id: 'action_display', field_name: 'Stock action', enable: true, type: 'system' },
      { id: 'opening', field_name: 'Opening', enable: true, type: 'system' },
      { id: 'change', field_name: 'Trx', enable: true, type: 'system' },
      { id: 'balance', field_name: 'Balance', enable: true, type: 'system' },
      { id: 'providerName', field_name: 'Dispense by', enable: true, type: 'system' },
    ],
    dispenseDetailReportFields: [
      { id: 'datetime', field_name: 'Dispense date', enable: true, type: 'system' },
      { id: 'ic', field_name: 'Patient id', enable: true, type: 'system' },
      { id: 'name', field_name: 'Patient name', enable: true, type: 'system' },
      { id: 'phone', field_name: 'Patient phone', enable: true, type: 'system' },
      { id: 'address', field_name: 'Patient address', enable: true, type: 'system' },
      { id: 'product', field_name: 'Drug name', enable: true, type: 'system' },
      { id: 'drugDosage', field_name: 'Drug dosage', enable: true, type: 'system' },
      { id: 'quantity', field_name: 'Dispense quantity', enable: true, type: 'system' },
    ],
    transactionSalesReportFields: [
      { id: 'datetime', field_name: 'Date and time', enable: true, type: 'system' },
      { id: 'ic', field_name: 'Patient id', enable: true, type: 'system' },
      { id: 'name', field_name: 'Patient name', enable: true, type: 'system' },
      { id: 'paymentMethod', field_name: 'Payment method', enable: true, type: 'system' },
      { id: 'amount', field_name: 'Amount {{currency}}', enable: true, type: 'system' },
    ],
    billingDetailSalesReportFields: [
      { id: 'datetime', field_name: 'Date and time', enable: true, type: 'system' },
      { id: 'ic', field_name: 'Patient id', enable: true, type: 'system' },
      { id: 'name', field_name: 'Patient name', enable: true, type: 'system' },
      { id: 'paymentMethod', field_name: 'Payment method', enable: true, type: 'system' },
      { id: 'amount', field_name: 'Amount {{currency}}', enable: true, type: 'system' },
      { id: 'panel', field_name: 'Panel {{currency}}', enable: true, type: 'system' },
      { id: 'cash', field_name: 'Cash {{currency}}', enable: true, type: 'system' },
      { id: 'non_cash', field_name: 'Non-cash {{currency}}', enable: true, type: 'system' },
      { id: 'due', field_name: 'Due {{currency}}', enable: true, type: 'system' },
    ],
    dailySalesReportFields: [
      { id: 'date', field_name: 'Date', enable: true, type: 'system' },
      { id: 'sales', field_name: 'Total sales {{currency}}', enable: true, type: 'system' },
      { id: 'leads', field_name: 'No of patients', enable: true, type: 'system' },
    ],
    salesByPanelReportFields: [
      { id: 'datetime', field_name: 'Date & time', enable: true, type: 'system' },
      { id: 'invoice_no', field_name: 'Invoice no', enable: true, type: 'system' },
      { id: 'staff_details', field_name: 'Staff details', enable: true, type: 'system' },
      { id: 'patient_details', field_name: 'Patient details', enable: true, type: 'system' },
      { id: 'panel_charge', field_name: 'Σ Panel {{currency}}', enable: true, type: 'system' },
      { id: 'approved', field_name: 'Σ Approved {{currency}}', enable: true, type: 'system' },
      { id: 'rejected', field_name: 'Σ Rejected {{currency}}', enable: true, type: 'system' },
      { id: 'admin_fee', field_name: 'Σ Admin fee {{currency}}', enable: true, type: 'system' },
      { id: 'received', field_name: 'Σ Received {{currency}}', enable: true, type: 'system' },
      { id: 'outstanding', field_name: 'Σ Outstanding {{currency}}', enable: true, type: 'system' },
    ],
    allPanelReportFields: [
      { id: 'datetime', field_name: 'Date and time', enable: true, type: 'system' },
      { id: 'rid', field_name: 'Invoice no', enable: true, type: 'system' },
      { id: 'staff_name', field_name: 'Staff name', enable: true, type: 'system' },
      { id: 'staff_ic', field_name: 'Staff ic', enable: true, type: 'system' },
      { id: 'name', field_name: 'Patient name', enable: true, type: 'system' },
      { id: 'ic', field_name: 'Patient ic', enable: true, type: 'system' },
      { id: 'relationship', field_name: 'Relationship', enable: true, type: 'system' },
      { id: 'amount', field_name: 'Total payment panel {{currency}}', enable: true, type: 'system' },
    ],
    allPanelInvoiceReportFields: [
      { id: 'datetime', field_name: 'Date and time', enable: true, type: 'system' },
      { id: 'rid', field_name: 'Invoice no', enable: true, type: 'system' },
      { id: 'staff_name', field_name: 'Staff name', enable: true, type: 'system' },
      { id: 'staff_ic', field_name: 'Staff ic', enable: true, type: 'system' },
      { id: 'name', field_name: 'Patient name', enable: true, type: 'system' },
      { id: 'ic', field_name: 'Patient ic', enable: true, type: 'system' },
      { id: 'relationship', field_name: 'Relationship', enable: true, type: 'system' },
      { id: 'mc_days', field_name: 'MC days', enable: true, type: 'system' },
      { id: 'diagnosis', field_name: 'Diagnosis', enable: true, type: 'system' },
      { id: 'amount', field_name: 'Total payment panel {{currency}}', enable: true, type: 'system' },
    ],
    purchaseHubQuotationFields: [
      { id: 'id', field_name: 'ID', enable: true, type: 'system' },
      { id: 'type', field_name: 'Type', enable: true, type: 'system' },
      { id: 'requestedBy', field_name: 'Requested by', enable: true, type: 'system' },
      { id: 'supplierName', field_name: 'Supplier', enable: true, type: 'system' },
      { id: 'sendTo', field_name: 'Send to', enable: true, type: 'system' },
      { id: 'rid', field_name: 'Reference', enable: true, type: 'system' },
      { id: 'dateIssued', field_name: 'Date issued', enable: true, type: 'system' },
      { id: 'requestStatus', field_name: 'Request status', enable: true, type: 'system' },
      { id: 'remarks', field_name: 'Remarks', enable: true, type: 'system' },
    ],
    purchaseHubOrderFields: [
      { id: 'id', field_name: 'ID', enable: true, type: 'system' },
      { id: 'type', field_name: 'Type', enable: true, type: 'system' },
      { id: 'requestedBy', field_name: 'Requested by', enable: true, type: 'system' },
      { id: 'supplierName', field_name: 'Supplier', enable: true, type: 'system' },
      { id: 'sendTo', field_name: 'Send to', enable: true, type: 'system' },
      { id: 'rid', field_name: 'Reference', enable: true, type: 'system' },
      { id: 'dateIssued', field_name: 'Date issued', enable: true, type: 'system' },
      { id: 'orderStatus', field_name: 'Order status', enable: true, type: 'system' },
      { id: 'inventoryStatus', field_name: 'Inventory status', enable: true, type: 'system' },
      { id: 'paymentStatus', field_name: 'Payment status', enable: true, type: 'system' },
      { id: 'unpaidBalance', field_name: 'Unpaid balance', enable: true, type: 'system' },
      { id: 'dueDate', field_name: 'Due date', enable: true, type: 'system' },
      { id: 'remarks', field_name: 'Remarks', enable: true, type: 'system' },
    ],
    purchaseHubInvoiceFields: [
      { id: 'id', field_name: 'ID', enable: true, type: 'system' },
      { id: 'type', field_name: 'Type', enable: true, type: 'system' },
      { id: 'requestedBy', field_name: 'Requested by', enable: true, type: 'system' },
      { id: 'supplierName', field_name: 'Supplier', enable: true, type: 'system' },
      { id: 'sendTo', field_name: 'Send to', enable: true, type: 'system' },
      { id: 'invoiceNumber', field_name: 'Invoice no', enable: true, type: 'system' },
      { id: 'rid', field_name: 'Reference', enable: true, type: 'system' },
      { id: 'dateIssued', field_name: 'Date issued', enable: true, type: 'system' },
      { id: 'amount', field_name: 'Amount', enable: true, type: 'system' },
      { id: 'orderStatus', field_name: 'Order status', enable: true, type: 'system' },
      { id: 'paymentStatus', field_name: 'Payment status', enable: true, type: 'system' },
      { id: 'unpaidBalance', field_name: 'Unpaid balance', enable: true, type: 'system' },
      { id: 'dueDate', field_name: 'Due date', enable: true, type: 'system' },
      { id: 'remarks', field_name: 'Remarks', enable: true, type: 'system' },
    ],
    inventoryListFields: [
      { id: 'name', field_name: 'Name', enable: true, type: 'system' },
      { id: 'total_item', field_name: 'Total item', enable: true, type: 'system' },
      { id: 'created', field_name: 'Created date', enable: true, type: 'system' },
      { id: 'order_freq', field_name: 'Order frequency', enable: true, type: 'system' },
      { id: 'remarks', field_name: 'Remarks', enable: true, type: 'system' },
    ],
    allPanelInvoiceFields: [
      { id: 'datetime', field_name: 'Date and time', enable: true, type: 'system' },
      { id: 'staff_name', field_name: 'Staff name', enable: true, type: 'system' },
      { id: 'staff_ic', field_name: 'Staff ic', enable: true, type: 'system' },
      { id: 'name', field_name: 'Patient name', enable: true, type: 'system' },
      { id: 'ic', field_name: 'Patient ic', enable: true, type: 'system' },
      { id: 'relationship', field_name: 'Relationship', enable: true, type: 'system' },
      { id: 'total_payment_panel', field_name: 'Total payment panel {{currency}}', enable: true, type: 'system' },
    ],
    offerFields: [
      { id: 'active_period', field_name: 'Active period', enable: true, type: 'system', width: 140 },
      { id: 'total_audiences', field_name: 'Customers', enable: true, type: 'system' },
      { id: 'redeemed', field_name: 'Redeemed', enable: true, type: 'system' },
      { id: 'conversion', field_name: 'Conversion', enable: true, type: 'system' },
      // { id: 'sales', field_name: 'Sales', enable: true, type: 'system' },
      { id: 'status', field_name: 'Status', enable: true, type: 'system' },
    ],
    loyaltyFields: [
      { id: 'phone', field_name: 'Phone Number', enable: true, type: 'system' },
      { id: 'name', field_name: 'Name', enable: true, type: 'system' },
      { id: 'status', field_name: 'Status', enable: true, type: 'system' },
      { id: 'progress', field_name: 'Progress', enable: true, type: 'system' },
      { id: 'time', field_name: 'Time', enable: true, type: 'system' },
      { id: 'total_spend', field_name: 'Total Spend', enable: true, type: 'system' },
    ],
    panelClaimInvoiceFields: [
      { id: 'amount', field_name: 'Amount', enable: true, type: 'system', sort_query_param: 'amount' },
      { id: 'invoiceNo', field_name: 'Invoice no', enable: true, type: 'system', sort_query_param: 'invoice_no' },
      { id: 'panel', field_name: 'Panel', enable: true, type: 'system', sort_query_param: 'panel__name' },
      { id: 'patientName', field_name: 'Patient name', enable: true, type: 'system', sort_query_param: 'patient__name' },
      { id: 'status', field_name: 'Status', enable: true, type: 'system', sort_query_param: 'status' },
      { id: 'visitDate', field_name: 'Visit date', enable: true, type: 'system', sort_query_param: 'visit_date' },
      { id: 'dueDate', field_name: 'Due date', enable: true, type: 'system', sort_query_param: 'submission_due' },
      { id: 'updatedBy', field_name: 'Updated by', enable: true, type: 'system', sort_query_param: 'updated_by__name' },
      { id: 'remarks', field_name: 'Remarks', enable: true, type: 'system', sort_query_param: 'internal_description' },
    ],
    panelClaimFields: [
      { id: 'amount', field_name: 'Amount', enable: true, type: 'system', sort_query_param: 'amount' },
      { id: 'claimNo', field_name: 'Claim no', enable: true, type: 'system', sort_query_param: 'rid' },
      { id: 'panel', field_name: 'Panel', enable: true, type: 'system', sort_query_param: 'panel' },
      { id: 'patientName', field_name: 'Patient name', enable: true, type: 'system', sort_query_param: 'patient__name' },
      { id: 'status', field_name: 'Status', enable: true, type: 'system', sort_query_param: 'status' },
      { id: 'date', field_name: 'Date', enable: true, type: 'system', sort_query_param: 'date' },
      { id: 'updatedBy', field_name: 'Updated by', enable: true, type: 'system', sort_query_param: 'updated_by__name' },
      { id: 'remarks', field_name: 'Remarks', enable: true, type: 'system', sort_query_param: 'internal_description' },
    ],
    cmsOsV2Enabled: false,
    cmsOsV2Fetched: false,
    selectedAppointmentView: 'list',
    panelClaim: {
      dates: null,
      beginDate: null,
      untilDate: null,
      currentDateRange: null,
    }
  },
  mutations: {
    setClinic(state, data) {
      state.clinic = data
    },
    setForm(state, data) {
      state.form = data
    },
    setProvider(state, data) {
      state.provider = data
    },
    setService(state, data) {
      state.service = data
    },
    setCustomFields(state, fields) {
      state.customFields = fields ?? []
    },
    setDatabinKey(state, key) {
      state.databinKey = key
    },
    setSelectedAppointmentView(state, selection) {
      localStorage.setItem('yz_selected_appointment_view', selection)
      state.selectedAppointmentView = selection
    },
    setPatientHistoryView(state, data) {
      localStorage.setItem('yz_patient_history_view', data)
      state.patientHistoryView = data
    },
    setVitalSignHideEmptyColumns(state, data) {
      localStorage.setItem('yz_vital_sign_hide_empty_column', data)
      state.vitalSignHideEmptyColumns = data
    },
    updateTempProvider(state, data) {
      state.tempProvider = { ...state.tempProvider, ...data }
    },
    updateTempService(state, data) {
      state.tempService = { ...state.tempService, ...data }
    },
    updateTempAppointment(state, data) {
      state.tempAppointment = { ...state.tempAppointment, ...data }
    },
    updateTempAppointmentDetails(state, data) {
      state.tempAppointmentDetails = { ...state.tempAppointmentDetails, ...data }
    },
    updateTempLoading(state, data) {
      state.tempLoading = data
    },
    resetClinic(state) {
      state.clinic = null
    },
    resetForm(state) {
      state.form = null
    },
    resetProvider(state) {
      state.provider = null
    },
    resetService(state) {
      state.service = null
    },
    resetTempProvider(state) {
      state.tempProvider = {}
    },
    resetTempService(state) {
      state.tempService = {}
    },
    resetTempAppointment(state) {
      state.tempAppointment = {}
      state.tempAppointmentDetails = {}
    },
    resetTempAppointmentDetails(state) {
      state.tempAppointmentDetails = {}
    },
    resetDatabinKey(state) {
      state.databinKey = null
    },
    setCmsOsV2(state, enabled) {
      state.cmsOsV2Enabled = enabled
      state.cmsOsV2Fetched = true
    },
    setPanelClaimDates(state, data) {
      state.panelClaim.dates = data
    },
    setPanelClaimBeginDate(state, data) {
      state.panelClaim.beginDate = data
    },
    setPanelClaimUntilDate(state, data) {
      state.panelClaim.untilDate = data
    },
    setPanelClaimCurrentDateRange(state, data) {
      state.panelClaim.currentDateRange = data
    },
  },
  actions: {
    async fetchCmsOsV2({ commit, state, rootGetters }, axios) {
      if (state.cmsOsV2Fetched) return state.cmsOsV2Enabled
      const company = rootGetters.getCompany
      if (!company?.id) return false
      try {
        const resp = await axios.get(`/companies/${company.id}/settings`, {
          params: { name: 'cms.os.v2', include_hq: true }
        })
        const enabled = resp.data.count > 0
        commit('setCmsOsV2', enabled)
        return enabled
      } catch {
        return false
      }
    },
    async enableCmsOsV2({ commit, rootGetters }, axios) {
      const company = rootGetters.getCompany
      await axios.post(`/companies/${company.id}/settings/`, {
        name: 'cms.os.v2',
        enabled: true
      })
      commit('setCmsOsV2', true)
    }
  },
  getters: {
    getClinic(state) {
      return state.clinic
    },
    getForm(state) {
      return state.form
    },
    getProvider(state) {
      return state.provider
    },
    getService(state) {
      return state.service
    },
    getTempProvider(state) {
      return state.tempProvider
    },
    getTempService(state) {
      return state.tempService
    },
    getTempAppointment(state) {
      return state.tempAppointment
    },
    getTempAppointmentDetails(state) {
      return state.tempAppointmentDetails
    },
    getTempLoading(state) {
      return state.tempLoading
    },
    getSystemProviders(state) {
      return state.systemProviders
    },
    getRaces (state) {
      return state.races
    },
    getReligions (state) {
      return state.religions
    },
    getCustomFields (state) {
      return state.customFields
    },
    getAllFields (state) {
      const fields = [...state.systemFields, ...state.customFields]
      const savedFields = JSON.parse(localStorage.getItem('yz_patient_fields'))
      if (savedFields) {
        fields.map(field => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getPatientFields (state) {
      const fields = [...state.patientFields, ...state.customFields]
      const savedFields = JSON.parse(localStorage.getItem('yz_patient_fields'))
      if (savedFields) {
        fields.map(field => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getAppointmentFields(state) {
      const fields = state.appointmentFields
      const savedFields = JSON.parse(localStorage.getItem('yz_appointment_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getAppointmentScheduleFields(state) {
      const fields = state.appointmentScheduleFields
      const savedFields = JSON.parse(localStorage.getItem('yz_appointment_schedule_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getAppointmentRequestFields(state) {
      const fields = state.appointmentRequestFields
      const savedFields = JSON.parse(localStorage.getItem('yz_appointment_request_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getReviewInvitationFields(state) {
      const fields = state.reviewInvitationFields
      const savedFields = JSON.parse(localStorage.getItem('yz_clinic_review_invitation_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getRegistrationFields(state) {
      const fields = state.registrationFields
      const savedFields = JSON.parse(localStorage.getItem('yz_registration_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getReservationFields(state) {
      const fields = state.reservationFields
      const savedFields = JSON.parse(localStorage.getItem('yz_reservation_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getPreorderFields(state) {
      const fields = state.preorderFields
      const savedFields = JSON.parse(localStorage.getItem('yz_preorder_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getInventoryFields(state) {
      const fields = state.inventoryFields
      const savedFields = JSON.parse(localStorage.getItem('yz_inventory_fields'))
      if (savedFields) {
        const currentIds = fields.map(f => f.id)
        const hasStaleIds = savedFields.some(id => !currentIds.includes(id))
        if (hasStaleIds) {
          localStorage.removeItem('yz_inventory_fields')
          return fields
        }
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getServiceFields(state) {
      const fields = state.serviceFields
      const savedFields = JSON.parse(localStorage.getItem('yz_service_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getPackageFields(state) {
      const fields = state.packageFields
      const savedFields = JSON.parse(localStorage.getItem('yz_package_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getStocktakeFields(state) {
      const fields = state.stocktakeFields
      const savedFields = JSON.parse(localStorage.getItem('yz_stocktake_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getLocationFields(state) {
      const fields = state.locationFields
      const savedFields = JSON.parse(localStorage.getItem('yz_location_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getBillingFields(state) {
      const fields = state.billingFields
      const savedFields = JSON.parse(localStorage.getItem('yz_billing_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getInventoryInvoiceFields(state) {
      const fields = state.inventoryInvoiceFields
      const savedFields = JSON.parse(localStorage.getItem('yz_inventory_invoice_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getUserFields(state) {
      const fields = state.userFields
      const savedFields = JSON.parse(localStorage.getItem('yz_user_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getDatabinKey(state) {
      return state.databinKey
    },
    getDoctorVisitFields(state) {
      const fields = state.doctorVisitFields
      const savedFields = JSON.parse(localStorage.getItem('yz_doctor_visit_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getNonDoctorVisitFields(state) {
      const fields = state.nonDoctorVisitFields
      const savedFields = JSON.parse(localStorage.getItem('yz_non_doctor_visit_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getAllPrescriptionReportFields(state) {
      const fields = state.allPrescriptionReportFields
      const savedFields = JSON.parse(localStorage.getItem('yz_all_prescription_report_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getDispenseDetailReportFields(state) {
      const fields = state.dispenseDetailReportFields
      const savedFields = JSON.parse(localStorage.getItem('yz_dispense_detail_report_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getTransactionSalesReportFields(state, getters, rootState, rootGetters) {
      const fields = state.transactionSalesReportFields
      const savedFields = JSON.parse(localStorage.getItem('yz_transaction_sales_report_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      const currency = rootGetters.getCompanyCurrency
      fields.map(field => {
        if (field.field_name.includes('{{currency}}')) {
          field.field_name = field.field_name.replace('{{currency}}', `(${currency.symbol})`)
        }
      })
      return fields
    },
    getBillingDetailSalesReportFields(state, getters, rootState, rootGetters) {
      const fields = state.billingDetailSalesReportFields
      const savedFields = JSON.parse(localStorage.getItem('yz_billing_detail_sales_report_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      const currency = rootGetters.getCompanyCurrency
      fields.map(field => {
        if (field.field_name.includes('{{currency}}')) {
          field.field_name = field.field_name.replace('{{currency}}', `(${currency.symbol})`)
        }
      })
      return fields
    },
    getDailySalesReportFields(state, getters, rootState, rootGetters) {
      const fields = state.dailySalesReportFields
      const savedFields = JSON.parse(localStorage.getItem('yz_daily_sales_report_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      const currency = rootGetters.getCompanyCurrency
      fields.map(field => {
        if (field.field_name.includes('{{currency}}')) {
          field.field_name = field.field_name.replace('{{currency}}', `(${currency.symbol})`)
        }
      })
      return fields
    },
    getSalesByPanelReportFields(state, getters, rootState, rootGetters) {
      const fields = state.salesByPanelReportFields
      const savedFields = JSON.parse(localStorage.getItem('yz_sales_by_panel_report_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      const currency = rootGetters.getCompanyCurrency
      fields.map(field => {
        if (field.field_name.includes('{{currency}}')) {
          field.field_name = field.field_name.replace('{{currency}}', `(${currency.symbol})`)
        }
      })
      return fields
    },
    getAllPanelReportFields(state, getters, rootState, rootGetters) {
      const fields = state.allPanelReportFields
      const savedFields = JSON.parse(localStorage.getItem('yz_all_panel_report_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      const currency = rootGetters.getCompanyCurrency
      fields.map(field => {
        if (field.field_name.includes('{{currency}}')) {
          field.field_name = field.field_name.replace('{{currency}}', `(${currency.symbol})`)
        }
      })
      return fields
    },
    getAllPanelInvoiceReportFields(state, getters, rootState, rootGetters) {
      const fields = state.allPanelInvoiceReportFields
      const savedFields = JSON.parse(localStorage.getItem('yz_all_panel_invoice_report_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      const currency = rootGetters.getCompanyCurrency
      fields.map(field => {
        if (field.field_name.includes('{{currency}}')) {
          field.field_name = field.field_name.replace('{{currency}}', `(${currency.symbol})`)
        }
      })
      return fields
    },
    getSelectedAppointmentView(state) {
      return state.selectedAppointmentView
    },
    getPatientHistoryView(state) {
      let view = state.patientHistoryView
      const savedState = localStorage.getItem('yz_patient_history_view')
      if (savedState) {
        view = savedState
      }
      return view
    },
    getVitalSignHideEmptyColumns(state) {
      let hide = state.vitalSignHideEmptyColumns
      const savedState = localStorage.getItem('yz_vital_sign_hide_empty_column')
      if (savedState === true || savedState === false) {
        hide = savedState
      }
      return hide
    },
    getVisitSummarySections(state) {
      const fields = state.visitSummarySections
      const savedFields = JSON.parse(localStorage.getItem('yz_visit_summary_sections'))
      if (savedFields) {
        for (const key in fields) {
          fields[key] = savedFields[key]
        }
      }
      return fields
    },
    getVitalSignsSections(state) {
      const fields = state.vitalSignsSections
      const savedFields = JSON.parse(localStorage.getItem('yz_vital_signs_sections'))
      if (savedFields) {
        for (const key in fields) {
          fields[key] = savedFields[key]
        }
      }
      return fields
    },
    getPurchaseHubQuotationFields(state) {
      const fields = state.purchaseHubQuotationFields
      const savedFields = JSON.parse(localStorage.getItem('yz_purchase_hub_quotation_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getPurchaseHubOrderFields(state) {
      const fields = state.purchaseHubOrderFields
      const savedFields = JSON.parse(localStorage.getItem('yz_purchase_hub_order_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getPurchaseHubInvoiceFields(state) {
      const fields = state.purchaseHubInvoiceFields
      const savedFields = JSON.parse(localStorage.getItem('yz_purchase_hub_invoice_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getInventoryListFields(state) {
      const fields = state.inventoryListFields
      const savedFields = JSON.parse(localStorage.getItem('yz_inventory_list_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getAllPanelInvoiceFields(state, getters, rootState, rootGetters) {
      const fields = state.allPanelInvoiceFields
      const savedFields = JSON.parse(localStorage.getItem('yz_all_panel_invoice_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      const currency = rootGetters.getCompanyCurrency
      fields.map(field => {
        if (field.field_name.includes('{{currency}}')) {
          field.field_name = field.field_name.replace('{{currency}}', `(${currency.symbol})`)
        }
      })
      return fields
    },
    getOfferFields(state) {
      const fields = state.offerFields
      const savedFields = JSON.parse(localStorage.getItem('yz_offer_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getLoyaltyFields(state) {
      const fields = state.loyaltyFields
      const savedFields = JSON.parse(localStorage.getItem('yz_loyalty_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getPanelClaimInvoiceFields(state) {
      const fields = state.panelClaimInvoiceFields
      const savedFields = JSON.parse(localStorage.getItem('yz_panel_claim_invoice_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getPanelClaimFields(state) {
      const fields = state.panelClaimFields
      const savedFields = JSON.parse(localStorage.getItem('yz_panel_claim_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getPanelClaimDates(state) {
      return state.panelClaim.dates
    },
    getPanelClaimBeginDate(state) {
      return state.panelClaim.beginDate
    },
    getPanelClaimUntilDate(state) {
      return state.panelClaim.untilDate
    },
    getPanelClaimCurrentDateRange(state) {
      return state.panelClaim.currentDateRange
    },
    isCmsOsV2Enabled(state) {
      return state.cmsOsV2Enabled
    },
  },
}